import { render } from "./SystemSettingSection.vue?vue&type=template&id=297e9ab2"
import script from "./SystemSettingSection.vue?vue&type=script&lang=js"
export * from "./SystemSettingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__